import bulmaQuickview from "bulma-quickview/dist/js/bulma-quickview.min.js";

function attachQuickview() {
  bulmaQuickview.attach();
}

document.addEventListener("DOMContentLoaded", attachQuickview);
document.addEventListener("turbo:load", attachQuickview);
